<template>
  <div>
    <b-form-group label="Select Epic" label-class="font-weight-bold">
      <b-form-select
          v-model="selectedEpic"
          :options="epics"
          text-field="task_title"
          value-field="id"
          class="mb-3 w-50"
          @change="onEpicSelect"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            -- Select an Epic --
          </b-form-select-option>
        </template>
      </b-form-select>

      <div v-if="selectedEpic">
        <b-form-group
            v-for="risk in risks"
            :key="risk.key"
            :label="risk.label"
            label-class="font-weight-bold"
            class="mb-2"
        >
          <div class="d-flex align-items-center">
            <b-form-input
                type="number"
                v-model="form[risk.key]"
                class="w-50 mr-3"
            />

              <!-- for future-->

<!--            <b-form-checkbox-->
<!--                v-model="syncRisks[risk]"-->
<!--                :disabled="!selectedEpic"-->
<!--                class="ml-2"-->
<!--            >-->
<!--              Sync to all Epics-->
<!--            </b-form-checkbox>-->
          </div>
        </b-form-group>
      </div>
    </b-form-group>

    <b-table
        v-if="epics.length > 0"
        :items="tableItems"
        :fields="tableFields"
        striped
        hover
        responsive
        sticky-header
    >
      <template #cell(task_estimation)="{ item }">
        <span>{{ msToTime(item.task_estimation) }}</span>
      </template>
    </b-table>

    <div class="d-flex justify-content-between">
      <span class="font-weight-bolder font-medium-3">Subtotal: {{ msToTime(epicTasksTimeSubtotal) }}</span>
      <b-button
          variant="primary"
          :disabled="loading"
          @click="generate"
      >
        Generate
      </b-button>
    </div>
    <b-modal
      id="epicReportPreviewModal"
      v-if="selectedEpic"
      :centered="true"
      size="xl"
      :title="`Epic result preview:`"
    >
      <iframe
          :src="blobUrl"
          width="100%"
          height="600px"
          frameborder="0"
      />

    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import useJwt from "@/auth/jwt/useJwt";
import {
  BCard,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BTable,
  BFormInput,
  BButton,
  BIcon,
  BFormCheckbox,
  BModal
} from "bootstrap-vue";
import {msToTime} from "@/_helpers/time";

export default {
  components: {
    BModal,
    BCard,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BTable,
    BFormInput,
    BButton,
    BIcon,
    BFormCheckbox,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      epics: [],
      epicsTasks: [],
      selectedEpic: null,
      risks: [
        {
          key: 'risks',
          label: 'Risk'
        },
        {
          key: 'pm_ba',
          label: 'PM/BA'
        },
        {
          key: 'qa',
          label: 'QA'
        },
        {
          key: 'bugfix',
          label: 'Bugfix'
        }
      ],
      form: {},
      blobUrl: null,
      loading: false,
      // syncRisks: {
      //   risks: false,
      //   pm_qa: false,
      //   bugfix: false,
      // },
      tableFields: [
        { key: 'task_title', label: 'Task' },
        { key: 'task_estimation', label: 'Task ETA' },
      ],
    };
  },
  computed: {
    tableItems() {
      return this.epicsTasks.map(task => ({
        task_title: task.task_title,
        task_estimation: task.task_estimation,
      }));
    },
    epicTasksTimeSubtotal() {
      return this.epicsTasks.reduce((sum, t) => sum + t.task_estimation, 0)
    }
  },
  async beforeMount() {
    await this.initEpics();
  },
  methods: {
    msToTime,
    async initEpics() {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/project/${this.projectId}/epics`, {
          headers: { Authorization: `Bearer ${useJwt.getToken()}` },
        });
        this.epics = [...data.data];
      } catch (error) {
        console.error('Error fetching epics:', error);
        this.epics = [];
      }
    },
    async getEpicTasks(epicId) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/epic/${epicId}/tasks`, {
          headers: { Authorization: `Bearer ${useJwt.getToken()}` },
        });
        this.epicsTasks = [...data.data];
      } catch (error) {
        console.error('Error fetching epics:', error);
        this.epicsTasks = [];
      }
    },
    updateForm(epicId, risk, value) {
      if (!this.form[epicId]) {
        this.form[epicId] = {
          risks: null,
          pm_qa: null,
          bugfix: null,
        };
      }
      const newValue = value ? Number(value) : null;
      this.form[epicId] = {
        ...this.form[epicId],
        [risk]: newValue,
      };

      // if (this.syncRisks[risk]) {
      //   this.syncRisk(risk, newValue);
      // }
    },
    syncRisk(riskType, value) {
      if (!this.selectedEpic) return;

      this.form = Object.keys(this.form).reduce((acc, epicId) => {
        acc[epicId] = {
          ...this.form[epicId],
          [riskType]: value,
        };
        return acc;
      }, {});
    },
    generate() {
      this.loading = true
      axios.post(`${process.env.VUE_APP_API_URL}/reporting/epic/${this.selectedEpic}/pdf`, this.form, {
        headers: {
          Authorization: `Bearer ${useJwt.getToken()}`,
        },
        responseType: 'blob',
      }).then(response => {
            this.html2PdfSetup = new Blob([response.data], { type: 'application/pdf' })
            this.blobUrl = window.URL.createObjectURL(this.html2PdfSetup)
            this.pdfReport = this.html2PdfSetup
            this.$bvModal.show('epicReportPreviewModal')
          }).finally(() => {
            this.loading = false
      })
    },
    async onEpicSelect(epicId) {
      await this.getEpicTasks(epicId)
    }
  },
};
</script>

<style scoped>
</style>